(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tero-mobile-purchase')) {
customElements.define('tero-mobile-purchase', class extends HTMLElement {
connectedCallback() {
this.frame = requestAnimationFrame(() => {
if (!this.isConnected) return;
this.form = document.getElementById(this.dataset.formId);
if (!this.form) return;
this.source = this.form.querySelector('button[type="submit"]');
this.button = this.querySelector('button');
this.price = this.querySelector('.tero-mobile-price');
if (!this.source || !this.button) return;
this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
this.defaultLabel = this.button.textContent;
this.sync = () => {
const variantId = this.form.querySelector('input[name="id"]')?.value;
const variant = this.variants.find(item => String(item.id) === variantId);
if (variant) this.price.textContent = variant.price;
this.button.disabled = this.source.disabled;
this.button.textContent = this.source.disabled ? this.source.textContent.trim() : this.defaultLabel;
};
this.observer = new MutationObserver(this.sync);
this.observer.observe(this.form, { attributes: true, childList: true, subtree: true });
this.form.addEventListener('change', this.sync);
this.intersection = new IntersectionObserver(entries => { this.classList.toggle('is-visible', !entries[0].isIntersecting); });
this.intersection.observe(this.source);
this.sync();
});
}
disconnectedCallback() {
cancelAnimationFrame(this.frame);
this.observer?.disconnect(); this.intersection?.disconnect();
this.form?.removeEventListener('change', this.sync);
}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["crooked-product-grid"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__cpgQuickAddBound) return;
    window.__cpgQuickAddBound = true;

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-cpg-add]');
      if (!button) return;
      event.preventDefault();

      const sectionIds = [...document.querySelectorAll('cart-items-component')]
        .map((el) => el.dataset.sectionId)
        .filter(Boolean);

      button.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(button.dataset.cpgAdd), quantity: 1 }],
            sections: sectionIds.join(','),
          }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message);

        const { CartAddEvent } = await import('@theme/events');
        document.dispatchEvent(
          new CartAddEvent({}, button.dataset.cpgAdd, {
            source: 'product-form-component',
            itemCount: 1,
            variantId: button.dataset.cpgAdd,
            sections: data.sections,
          })
        );
      } catch (error) {
        console.error(error);
        alert(error.message || 'Could not add to cart');
      } finally {
        button.removeAttribute('aria-busy');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
